import React from "react";
import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";

export function LanguageSwitcher({ className = "" }) {
  const { lang, toggle } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid="language-switcher"
      className={`inline-flex items-center gap-2 rounded-full border border-white/10 px-3 py-1.5 text-sm text-slate-200 hover:border-brand-cyan/50 hover:text-brand-cyan transition-colors ${className}`}
    >
      <Globe className="h-4 w-4" />
      <span className="font-medium">{lang === "en" ? "AR" : "EN"}</span>
    </button>
  );
}
